module.exports = __webpack_public_path__ + "static/media/gel-side.69d35187.svg";